import { render, staticRenderFns } from "./BadgeEditor.vue?vue&type=template&id=17502492&scoped=true&"
import script from "./BadgeEditor.vue?vue&type=script&lang=js&"
export * from "./BadgeEditor.vue?vue&type=script&lang=js&"
import style0 from "./BadgeEditor.vue?vue&type=style&index=0&id=17502492&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17502492",
  null
  
)

export default component.exports